// extracted by mini-css-extract-plugin
export default {"sponsoredAdsCard":"D7-z","displaySixCardTiles":"E7-z"};